export default '/build/eef9d80f.svg'